// extracted by mini-css-extract-plugin
export default {"OneCard_container":"OneCard_OneCard_container__vdsln","OneCard_itemBox":"OneCard_OneCard_itemBox__UL96u"};